import {API_SERVER} from './index'

const API_CONFIG = {
    INDEXSTATUS: {
        url: `${API_SERVER}/oauth/getWeChatUserInfo`,
        method: 'get',
        header: false
    },
    GetCountryCode: {
        url: `${API_SERVER}/getCountryCode`,
        method: 'get',
        header: false
    },
    GetCustomerInfo: {
        url: `${API_SERVER}/memberProfile/retrieveMemberProfile`,
        method: 'post',
        header: false
    },
    sendEnrollmentForm: {
        url: `${API_SERVER}/enrollment`,
        method: 'post',
        header: false
    },
    sendLoginForm: {
        url: `${API_SERVER}/signIn`,
        method: 'post',
        header: false
    },
    GetPinYinTranslation: {
        url: `${API_SERVER}/transliterations`,
        method: 'get',
        header: true
    },
    GetWXconfig: {
        url: `${API_SERVER}/createJsapiSig`,
        method: 'get',
        header: false
    },
    CreateCardSig: {
        url: `${API_SERVER}/createCardSig`,
        method: 'get',
        header: false
    },
    GetCsrfToken: {
        url: `${API_SERVER}/retrieveCsrfToken`,
        method: 'get',
        header: false
    }
}
export default API_CONFIG



// WEBPACK FOOTER //
// ./src/config/api.js